/** @format */

const template = `
<div
  class="accordion-panel accordion-panel-noblock-dotted-content"
  ng-class="{'open': $ctrl.isOpen, 'highlighted': ($ctrl.highlightedModuleId === $ctrl.moduleId)}">
  <div class="header has-header-items">
    <button
      type="button"
      class="collapse non-button"
      ng-disabled="$ctrl.showSelectedParent"
      ng-click="$ctrl.toggleOpen()"
      ng-class="{'collapsed': !$ctrl.isOpen, 'disabled':  $ctrl.showSelectedParent}"
      aria-expanded="{{$ctrl.isOpen}}"
      aria-label="{{::$ctrl.module.name | localizedString}}">
      <sis-icon icon="chevron-ring-fill" [icon-class]="$ctrl.isOpen ? 'cw-90' : null"></sis-icon>
    </button>
    <div ng-if="$ctrl.isEducationOption" aria-label="{{::'ARIA_LABEL.STUDY_RIGHT' | translate}}">
      <sis-icon icon="junction"></sis-icon>
    </div>
    <div class="title">
      <sis-tooltip [append-to-body]="true" tooltip-class="tooltip-wide">
        <span class="sis-tooltip-trigger-content" aria-label="{{$ctrl.titleAriaLabel}}"
          ><span aria-hidden="true">{{:: $ctrl.module.name | localizedString }}</span></span
        >
        <div class="sis-tooltip-content">
          <div class="plan-structure-study-tooltip">
            <div class="study-name">{{:: $ctrl.module.name | localizedString }}</div>
            <div
              ng-if="$ctrl.isAttainmentGroupNode() || $ctrl.isGroupingModule()"
              class="first-level"
              translate="SIS_COMPONENTS.PLAN.STUDY_TOOLTIP.GROUPING_MODULE"></div>
            <div
              ng-if="$ctrl.isCustomAttainment()"
              class="first-level"
              translate="SIS_COMPONENTS.PLAN.STUDY_TOOLTIP.CUSTOM_ATTAINMENT"></div>
            <div ng-if="$ctrl.curriculumPeriods.length > 0" class="second-level">
              <div class="second-level-title" translate="SIS_COMPONENTS.PLAN.STUDY_TOOLTIP.CURRICULUM_PERIODS"></div>
              <ul>
                <li ng-repeat="curriculumPeriod in ::$ctrl.curriculumPeriods track by curriculumPeriod.id"
                  >{{ curriculumPeriod.name | localizedString }}</li
                >
              </ul>
            </div>
          </div>
        </div>
      </sis-tooltip>
      <span class="additional">
        <span ng-if="$ctrl.isAboutToExpire()" class="tiny-badge accent">
          <span translate>PLAN.MODULE.EXPIRATION_IMMINENT</span>
          {{ $ctrl.getExpiryDate() | localDateFormat }}
        </span>
        <span ng-if="$ctrl.isInvalidSelection($ctrl.module) && !$ctrl.hasModuleContentApproval($ctrl.module)" class="tiny-badge danger">
          <span translate>PLAN.INVALID_SELECTIONS.NOTIFICATION</span>
        </span>
        <span ng-if="$ctrl.isInvalidAccordingToModuleContentApproval($ctrl.module)" class="tiny-badge danger">
          <span translate>PLAN.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL.NOTIFICATION</span>
        </span>
        <span
          ng-if="$ctrl.module.documentState == 'DRAFT' || $ctrl.module.documentState == 'DELETED'"
          class="tiny-badge"
          ng-class="{'accent': $ctrl.module.documentState == 'DRAFT',
                         'danger': $ctrl.module.documentState == 'DELETED'}"
          translate="{{'DOCUMENT_STATE.'+$ctrl.module.documentState}}">
        </span>
        {{:: $ctrl.module.code }}
        <span ng-if="$ctrl.studyRightState"> | <span translate="{{'PLAN_STUDY_RIGHT_STATE.' + $ctrl.studyRightState}}"></span> </span>
        <span ng-if="$ctrl.requestedApplications[$ctrl.module.id]">
          <a
            ng-click="$ctrl.requestedApplications[$ctrl.module.id].navigateToApplication()"
            ng-href="{{$ctrl.requestedApplications[$ctrl.module.id].url}}"
            translate>
            SIS_COMPONENTS.PLAN.LABEL.NAVIGATE_TO_MODULE_EVALUATION
          </a>
          <sis-icon icon="alert" color="attention"></sis-icon>
        </span>
      </span>
    </div>
    <div class="title-line">
      <div class="title-line-liner"></div>
    </div>
    <div class="cell info-box" ng-if="$ctrl.showSelectedParent">
      <div><sis-icon icon="info"></sis-icon></div>
      <div class="info-text">{{'PLAN.MODULE.IMPLICIT_IN_MODULE' |translate}} {{ $ctrl.selectedParent.name | localizedString }}</div>
    </div>
    <ng-container ng-if="!$ctrl.isAttainmentGroupNode()">
      <div class="cell average" ng-if="$ctrl.showGradeAverage() && $ctrl.gradeAverage">{{$ctrl.gradeAverage}}</div>
      <div class="cell status">
        <div class="state-attained" ng-if="$ctrl.moduleValidationResults.state==='ATTAINED'">
          <span translate="SIS_COMPONENTS.PLAN_STATE.ATTAINED">suoritettu</span>
          <div>
            <sis-icon icon="achievement" color="success"></sis-icon>
            <span class="grade-text"> {{:: $ctrl.gradeAbbreviation | localizedString }} </span>
          </div>
        </div>
        <div ng-if="$ctrl.moduleValidationResults.state!=='ATTAINED'" ng-switch="$ctrl.getPlanState()">
          <div ng-switch-when="INVALID" class="state-invalid">
            <sis-icon icon="alert-fill"></sis-icon>
            <span ng-if="$ctrl.getPlanState()" translate>{{'SIS_COMPONENTS.PLAN_STATE.' + $ctrl.getPlanState()}}</span>
          </div>
          <div
            ng-switch-when="MODULECONTENTAPPROVAL_VALIDATION_STATE_INVALID_REQUESTED|MODULECONTENTAPPROVAL_VALIDATION_STATE_INVALID_ACCEPTED"
            ng-switch-when-separator="|"
            class="state-invalid">
            <sis-icon icon="alert-fill"></sis-icon>
            <span ng-if="$ctrl.getPlanState()" translate>{{'SIS_COMPONENTS.PLAN_STATE.' + $ctrl.getPlanState()}}</span>
          </div>
          <div ng-switch-default>
            <span ng-if="$ctrl.getPlanState()" translate>{{'SIS_COMPONENTS.PLAN_STATE.' + $ctrl.getPlanState()}}</span>
          </div>
        </div>
      </div>
      <div class="cell module-credits">
        <sis-tooltip
          tooltip-text="{{::'PROFILE.ATTAINMENT.CREDITS' | translate}} {{:: $ctrl.module.targetCredits | creditRange}} {{::'CREDITS' | translate}}"
          [append-to-body]="true">
          <div class="credit-range sis-tooltip-trigger-content">
            <span ng-class="{'no-target-credits':!$ctrl.module.targetCredits}"
              ><span ng-if="$ctrl.module.targetCredits">{{:: $ctrl.module.targetCredits | creditRange}}</span>
            </span>
          </div>
        </sis-tooltip>
        <div class="planned-attained-credits" ng-click="$ctrl.openModuleSelections()">
          <sis-tooltip
            ng-if="$ctrl.moduleValidationResults.plannedCredits && $ctrl.moduleValidationResults.plannedCredits.min !== 0 && $ctrl.moduleValidationResults.plannedCredits.max !== 0"
            tooltip-text="{{::'SIS_COMPONENTS.PLAN.LABEL.SELECTED_CREDITS' | translate}} {{::$ctrl.moduleValidationResults.plannedCredits | creditRange}} {{::'CREDITS' | translate}}"
            [append-to-body]="true"
            tooltip-placement="top-right">
            <div class="planned-credits sis-tooltip-trigger-content">
              {{::$ctrl.moduleValidationResults.plannedCredits | creditRange}}
            </div>
          </sis-tooltip>
          <sis-tooltip
            ng-if="!$ctrl.moduleValidationResults.plannedCredits || $ctrl.moduleValidationResults.plannedCredits.min === 0 && $ctrl.moduleValidationResults.plannedCredits.max === 0"
            tooltip-text="{{::'SIS_COMPONENTS.PLAN.LABEL.SELECTED_CREDITS' | translate}} - {{::'CREDITS' | translate}}"
            [append-to-body]="true"
            tooltip-placement="top-right">
            <div class="planned-credits sis-tooltip-trigger-content"> - </div>
          </sis-tooltip>
          <sis-tooltip
            ng-if="$ctrl.moduleValidationResults.attainedCredits"
            tooltip-text="{{::'SIS_COMPONENTS.PLAN.LABEL.ATTAINED' | translate}} {{::$ctrl.moduleValidationResults.attainedCredits | decimalNumber}} {{::'CREDITS' | translate}}"
            [append-to-body]="true"
            tooltip-placement="top-left">
            <div class="attained-credits sis-tooltip-trigger-content">
              {{:: $ctrl.moduleValidationResults.attainedCredits | decimalNumber}}
            </div>
          </sis-tooltip>
          <sis-tooltip
            ng-if="!$ctrl.moduleValidationResults.attainedCredits"
            tooltip-text="{{::'SIS_COMPONENTS.PLAN.LABEL.ATTAINED' | translate}} - {{::'CREDITS' | translate}}"
            [append-to-body]="true"
            tooltip-placement="top-left">
            <div class="attained-credits sis-tooltip-trigger-content"> - </div>
          </sis-tooltip>
        </div>
      </div>
    </ng-container>
    <div ng-if="$ctrl.showActionButtonColumn" class="cell action-button">
      <button
        type="button"
        class="btn btn-secondary btn-hollow btn-sm"
        ng-if="$ctrl.showModuleContentApprovalButtonVisible()"
        ng-click="$ctrl.showModuleContentApproval()">
        <span translate="SIS_COMPONENTS.PLAN.LABEL.SHOW_MODULE_CONTENT_APPROVAL">Näytä</span>
      </button>
    </div>
  </div>
  <div ng-if="!$ctrl.showSelectedParent && $ctrl.isOpen" class="content animate-if" ng-class="{collapsed: !$ctrl.isOpen}">
    <div class="content-row">
      <div class="content-text">
        <course-unit-with-substitutions
          ng-repeat="courseUnit in $ctrl.childCourseUnitSelections track by courseUnit.id"
          course-unit-id="{{::courseUnit.id}}"
          validatable-plan="$ctrl.validatablePlan"
          parent-module-group-id="$ctrl.module.groupId"
          show-expiry-warnings="true">
        </course-unit-with-substitutions
        ><!--
     --><div
          ng-if="$ctrl.hasCustomCourseUnitAttainments()"
          ng-repeat="customCourseUnitAttainment in $ctrl.childCustomCourseUnitAttainments track by customCourseUnitAttainment.id"
          class="tree-list-body-inner">
          <custom-course-unit-attainment-box
            validatable-plan="$ctrl.validatablePlan"
            show-course-unit-attainment-notification="true"
            attainment="customCourseUnitAttainment"
            grade="$ctrl.getGrade(customCourseUnitAttainment)"
            expiry-date="$ctrl.getCustomCourseUnitAttainmentExpiryDate(customCourseUnitAttainment)">
          </custom-course-unit-attainment-box> </div
        ><!--
     --><course-unit-with-substitutions
          ng-if="$ctrl.showImplicitSelections"
          ng-repeat="implicitCourseUnitId in $ctrl.getImplicitCourseUnitIds()"
          course-unit-id="{{::implicitCourseUnitId}}"
          validatable-plan="$ctrl.validatablePlan"
          parent-module-id="$ctrl.getParentModuleIdForCourseUnitId(implicitCourseUnitId)"
          show-expiry-warnings="true"
          show-selected-parent="true">
        </course-unit-with-substitutions
        ><!--
     --><div ng-repeat="customStudyDraft in $ctrl.customStudyDrafts track by customStudyDraft.id" class="tree-list-body-inner">
          <custom-study-draft
            custom-study-draft="customStudyDraft"
            on-modal-open="$ctrl.openCustomStudyDraftInfoModal(customStudyDraftObject)"></custom-study-draft> </div
        ><!--
     --><common-plan-module
          ng-repeat="module in $ctrl.childModuleSelections track by module.id"
          module-id="module.id"
          parent-module-id="$ctrl.module.id"
          plan="$ctrl.plan"
          plan-validation-result="$ctrl.planValidationResult"
          validatable-plan="$ctrl.validatablePlan"
          module-content-approvals="$ctrl.moduleContentApprovals"
          highlighted-module-id="$ctrl.highlightedModuleId"
          education-options="$ctrl.educationOptions"
          requested-applications="$ctrl.requestedApplications"
          show-implicit-selections="$ctrl.showImplicitSelections"
          show-action-button-column="$ctrl.showActionButtonColumn">
        </common-plan-module>
        <common-plan-module
          ng-repeat="subModule in $ctrl.moduleLikeItems track by subModule.id"
          module-attainment="subModule.attainment"
          module-id="subModule.id"
          parent-module-id="$ctrl.module.id"
          plan="$ctrl.plan"
          plan-validation-result="$ctrl.planValidationResult"
          validatable-plan="$ctrl.validatablePlan"
          education-options="$ctrl.educationOptions"
          requested-applications="$ctrl.requestedApplications"
          show-action-button-column="$ctrl.showActionButtonColumn">
        </common-plan-module>
        <common-plan-module
          ng-if="$ctrl.showImplicitSelections"
          ng-repeat="implicitModuleId in $ctrl.getImplicitModuleIds()"
          module-id="implicitModuleId"
          validatable-plan="$ctrl.validatablePlan"
          plan="$ctrl.plan"
          plan-validation-result="$ctrl.planValidationResult"
          education-options="$ctrl.educationOptions"
          requested-applications="$ctrl.requestedApplications"
          parent-module-id="$ctrl.getParentModuleIdForModuleId(implicitModuleId)"
          show-expiry-warnings="true"
          show-selected-parent="true"
          show-action-button-column="$ctrl.showActionButtonColumn">
        </common-plan-module>
      </div>
    </div>
  </div>
</div>
`;
export default template;
